/**
=========================================================
* Otis Admin PRO - v2.0.1
=========================================================

* Product Page: https://material-ui.com/store/items/otis-admin-pro-material-dashboard-react/
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ComplexStatisticsCard({
  title,
  count,
  icon,
  backgroundColor,
  clickable,
  clickHandler,
  ariaLabel,
  buttonLabel,
}) {
  return (
    <Card
      sx={{
        width: 360, // small fixed width
        height: 100, // increased height
        cursor: clickable ? "pointer" : "default",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
      onClick={clickable ? clickHandler : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={(e) => {
        if (e.keyCode === 13 && clickable) clickHandler();
      }}
      role={clickable ? "button" : "presentation"}
      aria-label={ariaLabel || `${title} card`}
    >
      <Grid container sx={{ height: "100%" }}>
        {/* Left - Icon section */}
        <Grid
          item
          xs={5}
          sx={{
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              fontSize: 80,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon fontSize="inherit" sx={{ color: backgroundColor }}>
              {icon}
            </Icon>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textAlign="center"
              sx={{ color: backgroundColor }}
            >
              {buttonLabel}
            </MDTypography>
          </Box>
        </Grid>

        {/* Right - Content section */}
        <Grid
          item
          xs={7}
          sx={{
            backgroundColor: backgroundColor,
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around", // vertical center
            alignItems: "center", // horizontal center
            padding: "0.3rem 0.5rem",
            textAlign: "center", // text alignment
            height: "100%",
          }}
        >
          <MDTypography variant="h2" fontWeight="bold" color="#fff">
            {count}
          </MDTypography>
          <MDTypography variant="body2" fontWeight="light" color="#fff" lineHeight={1}>
            {title}
          </MDTypography>
        </Grid>
      </Grid>
    </Card>
  );
}

ComplexStatisticsCard.defaultProps = {
  backgroundColor: "#2196f3",
  clickable: false,
  clickHandler: () => {},
  ariaLabel: "",
  buttonLabel: "",
};

ComplexStatisticsCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
  clickable: PropTypes.bool,
  clickHandler: PropTypes.func,
  ariaLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
};

export default ComplexStatisticsCard;
